import styled from "styled-components";
import { Box } from "@mui/material";

export const PricingPageWrapper = styled(Box)`
	padding: 88px 0 100px;
	overflow-x: clip;

	${props => props.theme.breakpoints.down("md")} {
		padding: 80px 0 80px;
	}
`;
